import Link from 'next/link';
import type { NextRouter } from 'next/router';
import { Fragment } from 'react';

import { AccordionV2 } from '@/components/common/AccordionV2/AccordionV2';
import type { MenuHierarchyRecordModelType } from '@/models/api';
import { useStore } from '@/models/root-store';
import type { MenuPath } from '@/shared/types';

interface IPageLinksDesktop {
  categoryMenuHierarchy: MenuHierarchyRecordModelType;
  currentPath?: string;
  router: NextRouter;
  menuPath?: MenuPath;
}

const PageLinksDesktop: React.FC<IPageLinksDesktop> = ({
  categoryMenuHierarchy,
  currentPath,
  router,
  menuPath,
}) => {
  const store = useStore();
  const {
    cartStore: {
      draftCart: { mode },
    },
  } = store;
  const { code } = router.query;
  const hasChildren = categoryMenuHierarchy?.childrenCategories?.length > 0;
  return (
    <ul className="mb-2 text-base lg:text-sm xl:text-base">
      <li
        key={categoryMenuHierarchy.id}
        className={`mb-2 flex items-center rounded pl-2 font-interBold ${
          categoryMenuHierarchy?.slug === menuPath?.subcategory &&
          !menuPath?.range
            ? 'bg-grey-liter'
            : ''
        }`}
      >
        <Link
          href={{
            pathname: `/${currentPath}/${categoryMenuHierarchy.slug}`,
            query: {
              ...(mode && { mode }),
              ...(code && { code }),
            },
          }}
        >
          All {categoryMenuHierarchy.name}
        </Link>
      </li>
      {hasChildren &&
        categoryMenuHierarchy.childrenCategories.map((link) => (
          <Fragment key={link.id}>
            {link.childrenCategories?.length > 0 ? (
              <AccordionV2
                className="mb-2 w-full pl-2"
                title={link.name || ''}
                expanded={menuPath?.subcategory === link.slug}
              >
                <ul className="ml-3">
                  <PageLinksDesktop
                    categoryMenuHierarchy={link}
                    currentPath={`${currentPath}/${categoryMenuHierarchy.slug}`}
                    router={router}
                    menuPath={menuPath}
                  />
                </ul>
              </AccordionV2>
            ) : (
              <li
                key={link.id}
                className={`mb-2 h-[24px] rounded pl-2 font-interSemibold ${
                  link?.slug === menuPath?.range ||
                  link?.slug === menuPath?.subcategory
                    ? 'bg-grey-liter'
                    : ''
                }`}
              >
                <Link
                  href={{
                    pathname: `/${currentPath}/${categoryMenuHierarchy.slug}/${link.slug}`,
                    query: {
                      ...(mode && { mode }),
                      ...(code && { code }),
                    },
                  }}
                >
                  {link.name}
                </Link>
              </li>
            )}
          </Fragment>
        ))}
    </ul>
  );
};

export default PageLinksDesktop;
